//
//
//
//
//
//
//
//
//
//
//
//
//

import Spinner from './components/Spinner.vue'
import Confirm from './components/Confirm.vue'

export default {
  name: 'App',

  components: {
    Spinner,
    Confirm
  },

  computed: {
    spinnerMessage() {
      return this.$store.state.spinnerMessage
    }
  },

  methods: {
    onResize() {
      // Stores the current viewport size in $store.state. This allows
      // templates to render different layouts according to screen
      // size (which can be much easier and more efficient that using css).
      this.$store.commit('set', ['width', window.innerWidth])
      this.$store.commit('set', ['height', window.innerHeight])
    },
    getCssClass() {
      return this.$store.getters.isMobile ? 'isMobile' : 'isNotMobile'
    }
  },

  beforeMount() {
    this.onResize()
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  }
}
